// import React from "react";
// import PolicyPage from "../../components/PolicyPage/PolicyPage";
// import consultationPolicyData from "./consultationPolicyData";

// export default function ConsultationPolicy() {
//   return <PolicyPage data={consultationPolicyData} />;
// }




import React from "react";
import { Helmet } from "react-helmet-async";
import PolicyPage from "../../components/PolicyPage/PolicyPage";
import consultationPolicyData from "./consultationPolicyData";

export default function ConsultationPolicy() {
  return (
    <>
      <Helmet>
        <title>
          Consultation Policy | Astro Logical Solutions
        </title>

        <meta
          name="description"
          content="Review the consultation policy of Astro Logical Solutions, including booking procedures, rescheduling, cancellations and session guidelines."
        />

        <link
          rel="canonical"
          href="https://astrologicalsolutions.in/consultation-policy"
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />

        <meta
          property="og:title"
          content="Consultation Policy | Astro Logical Solutions"
        />

        <meta
          property="og:description"
          content="Understand consultation bookings, rescheduling, cancellations and session guidelines at Astro Logical Solutions."
        />

        <meta
          property="og:url"
          content="https://astrologicalsolutions.in/consultation-policy"
        />

        <meta
          property="og:site_name"
          content="Astro Logical Solutions"
        />

        {/* Twitter Card */}
        <meta
          name="twitter:card"
          content="summary"
        />

        <meta
          name="twitter:title"
          content="Consultation Policy | Astro Logical Solutions"
        />

        <meta
          name="twitter:description"
          content="Understand consultation bookings, rescheduling, cancellations and session guidelines at Astro Logical Solutions."
        />
      </Helmet>

      <PolicyPage data={consultationPolicyData} />
    </>
  );
}